export default __webpack_public_path__ + "static/media/arrow-download.4d2b8bfd.svg";